import React, { useEffect, useState } from "react";
import CreateFreeTrialParent from "./CreateFreeTrialParent";
import ManageCampaignsModal from "./ManageCampaignsModal";
import SendEmailToLeadModal from "./SendEmailToLeadModal";
import Tooltip from "rsuite/Tooltip";
import Whisper from "rsuite/Whisper";
import { getFormattedDate } from "../../../../actions/common";
import { NavLink } from "react-router-dom";
import FreeTrialConfirmation from "./FreeTrialConfirmation";
import LoginToAccount from "./LoginToAccount";
import toast from "react-hot-toast";
import { el } from "date-fns/locale";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const DealsHeader = ({
  customerDetails,
  productsList,
  currentUser,
  refreshCustomerDetails,
  ismuvi5,
  createdDate,
}) => {
  const [showLoginToAccountModal, setShowLoginToAccountModal] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [createTrialModalOpen, setCreateTrialModalOpen] = useState(false);
  const [apiUrl, setApiUrl] = useState("");
  const [appToken, setAppToken] = useState("");
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [showSendEmailToLeadModal, setShowSendEmailToLeadModal] =
    useState(false);
  const [showManageCampaignsModal, setShowManageCampaignsModal] =
    useState(false);
  const [formData, setFormData] = useState({
    customerName: "",
    companyName: "",
    phoneNumber: "",
    emailId: "",
    password: "",
    products: [],
  });

  const history = useHistory();

  useEffect(() => {
    getLoginData();
  }, [customerDetails, ismuvi5]);

  const getLoginData = () => {
    if (!customerDetails) return;
    if (!customerDetails.product || customerDetails.product.length === 0)
      return;

    let data = {};
    const productKey =
      (customerDetails &&
        customerDetails.product &&
        customerDetails.product[0]) ||
      "";

    if (ismuvi5) {
      data = {
        title: `Login To Account`,
        confirmText: `Are you sure you want to log in to the account?`,
        product_key: productKey,
        enterprise_api_gateway_url: `${customerDetails.account_manager && customerDetails.account_type === "customer" ? `https://${customerDetails.domain}` : "https://cms.muvi.com"}`,
        encrypted_password: customerDetails.encrypted_password || "",
        email: customerDetails.email || "",
        store_id: "",
        isMuvi5: ismuvi5,
        customer_id: customerDetails.customer_id || "",
        mautic_id: customerDetails.mautic_id || "",
        studio_id: customerDetails.customer_id || "",
      };
    } else {
      data = {
        title: `Login To Account`,
        confirmText: `Are you sure you want to log in to the account?`,
        product_key: productKey,
        user_uuid: customerDetails.customer_user_uuid || "",
        customer_id: customerDetails.customer_id || "",
        mautic_id: customerDetails.mautic_id || "",
      };
    }

    setLoginData(data);
  };

  const handleShowLoginToAccountModal = () => {
    setShowLoginToAccountModal(true);
  };

  const handleCloseLoginToAccountModal = () => {
    setShowLoginToAccountModal(false);
  };

  const getRecentLogo = () => {
    let companyName = customerDetails.company_name;

    if (!companyName) {
      const email = (customerDetails ? customerDetails.email : "") || "";
      companyName = email.substring(0, email.indexOf("@"));
      if (!companyName) {
        companyName = "Unknown Contact";
      }
    }

    return (
      <img
        src={`https://ui-avatars.com/api/?name=${
          companyName || "Unknown Contact"
        }`}
        alt="Logo"
        class="store-logo"
      />
    );

  };


  const mailTriggerPopup = async (appToken) => {
    try {
      setCreateTrialModalOpen(false);
      setAppToken(appToken);
      const emailPayload = {
        username: formData.customerName,
        email: formData.emailId,
        login_url: process.env.REACT_APP_LOGIN_URL,
        password: formData.password,
      };

      const response = await fetch(`${apiUrl}/CrmRest/FreeTrialSuccess`, {
        method: "POST",
        body: JSON.stringify(emailPayload),
      });

      const successResult = await response.json();

      if (successResult && successResult.code === 200) {
        if (refreshCustomerDetails) {
          refreshCustomerDetails();
        }
        setEmailModalOpen(true);
      } else {
        console.error("Error in mail trigger popup:", successResult);
      }
    } catch (error) {
      console.error("Error triggering mail popup:", error);
    }
  };

  const getAvailableProductsForFreeTrial = () => {
    if (!customerDetails || !customerDetails.product) {
      return productsList.map((product, index) => {
        return {
          id: index + 1,
          label: product.value,
          value: product.product_key,
        };
      });
    }

    const usedProductKeys = customerDetails.product;

    const products = productsList.filter(
      (product) => !usedProductKeys.includes(product.product_key),
    );

    return products.map((product, index) => {
      return {
        id: index + 1,
        label: product.value,
        value: product.product_key,
      };
    });
  };

  return (
    <div class="crm-leads-header">
      <div class="navigation-buttons">
      </div>
      <div class="top-area p-8">
        <div class="profile-area border-0">
          <div class="profile-left" style={{ paddingTop: "8px" }}>
            <div class="img-box">{getRecentLogo()}</div>
            <div class="text-area">
              <div class="d-flex align-items-center">
                <div class="name" onClick={() => history.push(`/contact/${customerDetails.mautic_id}`)} style={{ cursor: "pointer" }}>{customerDetails.name || "-N/A-"}</div>

              </div>

              <div class="d-flex flex-profile-1" style={{ gap: "16px" }}>
                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Email</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => {
                        setShowSendEmailToLeadModal(true);
                      }}
                    >
                      <div class="icon-box me-0">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.94762 2.5614H14.2147V4.35659L7.93169 8.91103L1.6485 4.15712L1.94762 2.5614Z"
                            fill="#006EFA"
                          ></path>
                          <path
                            d="M2.66665 2.66666H13.3333C14.0666 2.66666 14.6666 3.26666 14.6666 3.99999V12C14.6666 12.7333 14.0666 13.3333 13.3333 13.3333H2.66665C1.93331 13.3333 1.33331 12.7333 1.33331 12V3.99999C1.33331 3.26666 1.93331 2.66666 2.66665 2.66666Z"
                            stroke="#006EFA"
                            stroke-width="1.33"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                          <path
                            d="M14.6666 4L7.99998 8.66667L1.33331 4"
                            stroke="#006EFA"
                            stroke-width="1.33"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>

                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Create Free Trial</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={() => {
                        setFormData({
                          ...formData,
                          customerName: customerDetails.name || "",
                          companyName: customerDetails.company_name || "",
                          phoneNumber: customerDetails.phone_number || "",
                          emailId: customerDetails.email || "",
                        });
                        setCreateTrialModalOpen(true);
                      }}
                    >
                      <div class="icon-box me-0">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Edit / Add_Plus_Circle">
                            <path
                              id="Vector"
                              d="M8 12H12M12 12H16M12 12V16M12 12V8M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
                              stroke="#006EFA"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>

                <div class="ps-0 pe-0">
                  <Whisper
                    placement="bottom"
                    trigger="hover"
                    speaker={<Tooltip>Login To Account</Tooltip>}
                  >
                    <button
                      class="single-box flex-direction-column align-items-center pt-0 pb-0 btn-ghost"
                      onClick={handleShowLoginToAccountModal}
                      disabled={
                        !customerDetails.product ||
                        customerDetails.product.length === 0
                      }
                    >
                      <div class="icon-box me-0">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill={
                            !customerDetails.product ||
                            customerDetails.product.length === 0
                              ? "#777"
                              : "#006EFA"
                          }
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2014_3381)">
                            <path d="M6.83337 7.87756H0.5C0.223999 7.87756 0 7.65356 0 7.37756C0 7.10156 0.223999 6.87756 0.5 6.87756H6.83337C7.10938 6.87756 7.33337 7.10156 7.33337 7.37756C7.33337 7.65356 7.10938 7.87756 6.83337 7.87756Z"></path>
                            <path d="M4.33337 10.3776C4.20532 10.3776 4.07739 10.3289 3.97998 10.231C3.78467 10.0355 3.78467 9.71887 3.97998 9.52356L6.12671 7.37695L3.97998 5.23096C3.78467 5.03552 3.78467 4.71887 3.97998 4.52356C4.17529 4.32825 4.49194 4.32825 4.68738 4.52356L7.18738 7.02356C7.38269 7.21887 7.38269 7.53552 7.18738 7.73096L4.68738 10.231C4.58936 10.3289 4.4613 10.3776 4.33337 10.3776Z"></path>
                            <path d="M10.6667 16C9.9314 16 9.3335 15.4064 9.3335 14.6765V2.76595C9.3335 2.20025 9.69617 1.69537 10.2361 1.50939L14.2415 0.184016C15.1375 -0.088596 16.0001 0.571124 16.0001 1.44263V13.3532C16.0001 13.9183 15.6375 14.4225 15.0981 14.609L11.0914 15.9352C10.9454 15.9801 10.8102 16 10.6667 16ZM14.6667 1.11174C14.6234 1.11174 14.5868 1.11707 14.5475 1.12895L10.5588 2.44899C10.4281 2.49407 10.3335 2.62504 10.3335 2.76595V14.6765C10.3335 14.9023 10.5801 15.0544 10.7861 14.9902L14.7748 13.6702C14.9048 13.6251 15.0001 13.4941 15.0001 13.3532V1.44263C15.0001 1.26065 14.8508 1.11174 14.6667 1.11174Z"></path>
                            <path d="M14.6667 1.11174C14.6234 1.11174 14.5868 1.11707 14.5475 1.12895L10.5588 2.44899C10.4281 2.49407 10.3335 2.62504 10.3335 2.76595V14.6765C10.3335 14.9023 10.5801 15.0544 10.7861 14.9902L14.7748 13.6702C14.9048 13.6251 15.0001 13.4941 15.0001 13.3532V1.44263C15.0001 1.26065 14.8508 1.11174 14.6667 1.11174Z"></path>
                            <path
                              d="M5.84668 3.54718C5.57068 3.54718 5.34668 3.32318 5.34668 3.04718V2.04718C5.34668 1.03583 6.16858 0.213806 7.17993 0.213806H14.6799C14.9559 0.213806 15.1799 0.437805 15.1799 0.713806C15.1799 0.989807 14.9559 1.21381 14.6799 1.21381H7.17993C6.72058 1.21381 6.34668 1.58783 6.34668 2.04718V3.04718C6.34668 3.32318 6.12268 3.54718 5.84668 3.54718Z"
                              // stroke="#006EFA"
                              stroke-width="0.3"
                            ></path>
                            <path
                              d="M9.83301 14.5409H7.16626C6.15491 14.5409 5.33301 13.7189 5.33301 12.7076V11.7076C5.33301 11.4315 5.55701 11.2076 5.83301 11.2076C6.10901 11.2076 6.33301 11.4315 6.33301 11.7076V12.7076C6.33301 13.1669 6.70691 13.5409 7.16626 13.5409H9.83301C10.109 13.5409 10.333 13.7649 10.333 14.0409C10.333 14.3169 10.109 14.5409 9.83301 14.5409Z"
                              // stroke="#006EFA"
                              stroke-width="0.3"
                            ></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_2014_3381">
                              <rect width="16" height="16" fill="white"></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </button>
                  </Whisper>
                </div>
              </div>
            </div>
          </div>

          <div className="last-activity">
            <svg
              width="6px"
              height="6px"
              viewBox="0 0 24.00 24.00"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              stroke="#28A745"
              stroke-width="0.00024000000000000003"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0">
                <rect
                  x="0"
                  y="0"
                  width="24.00"
                  height="24.00"
                  rx="12"
                  fill="#28A745"
                  strokewidth="0"
                ></rect>
              </g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="#28A745"
                stroke-width="0.624"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5Z"
                  fill="#28A745"
                ></path>
              </g>
            </svg>
            Deals Created:{" "}
            {getFormattedDate(createdDate, "MMM, dd yyyy 'at' hh:mm a")}
          </div>
        </div>
      </div>
      <CreateFreeTrialParent
        show={createTrialModalOpen}
        mailTriggerPopup={mailTriggerPopup}
        formData={formData}
        setFormData={setFormData}
        apiUrl={apiUrl}
        setApiUrl={setApiUrl}
        productOptions={getAvailableProductsForFreeTrial()}
        setModalOpen={setCreateTrialModalOpen}
        fixedCustomerDetails={true}
        mautic_id={customerDetails.mautic_id}
      />
      <LoginToAccount
        show={showLoginToAccountModal}
        data={loginData}
        close={handleCloseLoginToAccountModal}
      />
      <ManageCampaignsModal
        showModal={showManageCampaignsModal}
        closeModal={() => setShowManageCampaignsModal(false)}
        contactId={customerDetails.mautic_id}
      />
      <SendEmailToLeadModal
        showModal={showSendEmailToLeadModal}
        closeModal={() => setShowSendEmailToLeadModal(false)}
        contactId={customerDetails.mautic_id}
        currentUser={currentUser || {}}
      />
      <FreeTrialConfirmation
        formData={formData}
        show={emailModalOpen}
        close={setEmailModalOpen}
        handleOkClick={() => setEmailModalOpen(false)}
      />
    </div>
  );
};

export default DealsHeader;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/DealsHeader.js